"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let JobModal = class JobModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    id;
    onId(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("id");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.id !== null ? this.$fn.fetch('read_a_job', { parameters: { id: this.id } }) : null;
    }
    ux;
    b_7315092382398562_modalBindings;
    b_5074589820235598_model;
    dataMembers = ['item', 'ux', 'b_7315092382398562_modalBindings', 'b_5074589820235598_model'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "xl",
                },
                b_5074589820235598_model: "{{ item.created_by }",
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: ([this.item.number, this.$fn.gettext('Job')]),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3362_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_2140198529698299_setData_3368_getActionArgs($event) {
        return {
            path: "item",
            value: $event.data.response.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_2140198529698299_request_3366_getActionArgs($event) {
        return {
            operation: "update_job",
            data: {
                status: "Not Started",
            },
            parameters: {
                id: this.item.id,
            },
        };
    }
    async evh_2140198529698299_clickPreventStop(event, scope) {
        return await this.actions.evh_2140198529698299_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3362 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3362_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3361 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3362,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3361],
        });
        const act_2248226175642056_closeComponent_3364 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3363 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3364,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3363],
        });
        const act_2140198529698299_setData_3368 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2140198529698299_setData_3368_getActionArgs,
            events: [],
        });
        const evh_2140198529698299_success_3367 = new core_1.actions.EventHandlerImpl({
            action: act_2140198529698299_setData_3368,
            event: "success",
            displayName: "setData",
        });
        const act_2140198529698299_request_3366 = new core_1.actions.RequestAction({
            actionArgs: this.act_2140198529698299_request_3366_getActionArgs,
            displayName: "restart",
            events: [evh_2140198529698299_success_3367],
        });
        const evh_2140198529698299_clickPreventStop_3365 = new core_1.actions.EventHandlerImpl({
            action: act_2140198529698299_request_3366,
            event: "click.prevent.stop",
            displayName: "restart",
        });
        const evh_2140198529698299_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2140198529698299_clickPreventStop_3365],
        });
        return {
            act_7315092382398562_closeModal_3362,
            evh_7315092382398562_close_3361,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3364,
            evh_2248226175642056_close_3363,
            evh_2248226175642056_close,
            act_2140198529698299_setData_3368,
            evh_2140198529698299_success_3367,
            act_2140198529698299_request_3366,
            evh_2140198529698299_clickPreventStop_3365,
            evh_2140198529698299_clickPreventStop,
            restart: act_2140198529698299_request_3366,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], JobModal.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobModal.prototype, "onId", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "xl",
    }),
    __metadata("design:type", String)
], JobModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobModal.prototype, "onSize", null);
JobModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], JobModal);
exports.default = JobModal;
vue_property_decorator_1.Vue.component("JobModal", JobModal);
